import { CustomerCreateSheet } from '@/features/customers/ui/customer-create-sheet'
import { CustomerEditSheet } from '@/features/customers/ui/customer-edit-sheet'
import { MemberCreateSheet } from '@/features/hr/ui/member-create-sheet'
import { MemberDetailsSheet } from '@/features/hr/ui/member-details-sheet'
import { MemberEditSheet } from '@/features/hr/ui/member-edit-sheet'

const GlobalSheets = () => (
	<>
		<CustomerCreateSheet />
		<CustomerEditSheet />
		<MemberCreateSheet />
		<MemberDetailsSheet />
		<MemberEditSheet />
	</>
)

export { GlobalSheets }
